import moment from 'moment';
import { ODataObject } from '../../interfaces/odata-model.interface';
import { TimeUtilities } from '../../utilities/time-utilities';
import { CompositeModel } from '../complex/composite.model';
import { TimeZoneModel } from '../complex/time-zone.model';

export class WorkScheduleEntry {
    public timeZone: TimeZoneModel;
    public readonly workStart: moment.Moment;
    public readonly workEnd: moment.Moment;
    public constructor(
        workDate: string,
        startTime: string,
        endTime: string,
        public attendenceType: string,
        public comments: string,
        public utcDiff: string,
        public utcSign: '+' | '-',
        timeZone: string,
    ) {
        this.timeZone = new TimeZoneModel(moment.duration(utcDiff), utcSign, timeZone);
        this.workStart = TimeUtilities.momentFromDateAndTime(workDate, startTime);
        this.workEnd = TimeUtilities.momentFromDateAndTime(workDate, endTime);
    }

    public static fromODataWorkScheduleEntryModel(data: ODataWorkScheduleEntryModel): WorkScheduleEntry {
        return new WorkScheduleEntry(
            data.WorkDate,
            data.StartTime,
            data.EndTime,
            data.AttendenceType,
            data.Comments,
            data.UTCDiff,
            data.UTCSign,
            data.TimeZone,
        );
    }
}
export class WorkScheduleSetModel extends CompositeModel {
    public constructor(
        public frontId: string,
        public startDate: string,
        public plant: string,
        public salesOrg: string,
        public scheduleEntries: WorkScheduleEntry[],
    ) {
        super('WorkScheduleSetModel', {});
    }

    public static fromOData(data: ODataWorkScheduleModel): WorkScheduleSetModel {
        return new WorkScheduleSetModel(
            data.FrontId,
            data.StartDate,
            data.Plant,
            data.SalesOrg,
            data.ScheduleSet.results.map((c: ODataWorkScheduleEntryModel) => {
                return WorkScheduleEntry.fromODataWorkScheduleEntryModel(c);
            }),
        );
    }
}

export interface ODataWorkScheduleModel extends ODataObject {
    FrontId: string;
    StartDate: string;
    Plant: string;
    SalesOrg: string;
    ScheduleSet: {
        results: ODataWorkScheduleEntryModel[];
    };
}

export interface ODataWorkScheduleEntryModel extends ODataObject {
    __metadata: {
        id: string;
        uri: string;
        type: 'HC_SM_NGM_AA_SRV.Schedule';
    };
    WorkDate: string;
    StartTime: string;
    EndTime: string;
    AttendenceType: string;
    Comments: string;
    UTCDiff: string;
    UTCSign: '+' | '-';
    TimeZone: string;
}
